import { Chip, chipClasses, ChipProps, styled, Theme } from "@mui/material";
import typography from "../../styles/sbDesignSystem/sbTypography";

const getBackgroundColor = (theme: Theme, selected: boolean, variant: ChipProps["variant"] = "secondary") => {
  switch (variant) {
    case "primary":
      return selected ? theme.palette.primary30.main : theme.palette.primary10.main;
    case "secondary":
      return selected ? theme.palette.secondary30.main : theme.palette.secondary10.main;
  }
};

const getHoverColor = (theme: Theme, selected: boolean, variant: ChipProps["variant"] = "secondary") => {
  switch (variant) {
    case "primary":
      return theme.palette.primary20.main;
    case "secondary":
      return theme.palette.secondary20.main;
  }
};

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected: boolean; variant?: ChipProps["variant"] }>(({ selected, theme, variant }) => ({
  overflow: "hidden",
  gap: "12px",
  height: "26px",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  padding: "4px 12px 4px 12px",
  borderRadius: "8px",
  background: getBackgroundColor(theme, selected, variant),
  [`& .${chipClasses.label}`]: {
    ...(typography && typography["button.xSmall"]),
    color: selected ? theme.palette.text50.main : theme.palette.secondary80.main,
  },
  [`& .${chipClasses.deleteIcon}`]: {
    margin: "0px",
    color: theme.palette.text50.main,
  },
  "&:hover": {
    background: getHoverColor(theme, selected, variant),
  },
  [`& .${chipClasses.icon}`]: {
    marginRight: "0px",
    marginLeft: "0px",
  },
}));
const Pill = ({
  selected = false,
  ...props
}: {
  selected?: boolean;
} & ChipProps) => {
  return <StyledChip selected={selected} {...props}></StyledChip>;
};

export { Pill };
